import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { IonItem, IonLabel, IonList } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { CheckVersionService } from '@okcargo-apps/shared-infrastructure';

@Component({
  selector: 'lib-my-account-legal',
  templateUrl: './my-account-legal.component.html',
  styleUrls: ['./my-account-legal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, IonLabel, IonItem, IonList, TranslateModule],
})
export class MyAccountLegalComponent {
  private readonly checkVersionService = inject(CheckVersionService);

  public appVersionInfo = this.checkVersionService.localAppInfo;
}
